module.exports = __webpack_public_path__ + "img/prize_c1.c79b39f2.png";